import { calculate15DTotalValue } from 'neuro-calculation-commons';

const calculate15DTotal = sections => {
  if (sections && sections.yourHealthToday) {
    return sections.yourHealthToday; // added to handle EQ-5D ==> return the value of "Your Health Today"
  } else {
    return calculate15DTotalValue(sections);
  }
};

export default calculate15DTotal;
